jQuery(function ($) {
    if ( $('.top').length ) {
        if ( $('.posts__item.is-front-js').length ) {
            $('.posts__item.is-front-js').on('click', function() {
                $('.top__modal-bg').fadeIn('fast');
            });
        }
        if ( $('.top__modal-close-button').length ) {
            $('.top__modal-close-button').on('click', function() {
                $('.top__modal-bg').fadeOut('fast');
            });
        }
        if ( $('.shindan__button.is-next').length ) {
            $('.shindan__button.is-next').on('click', function() {
                if ( $('.shindan__button.is-next').hasClass('is-front-js') ) {
                    $('.top__modal-bg').fadeIn('fast');
                } else {
                    let key = $('input[name="question1"]:checked').val();
                    if ( Number(key) > 0 ) {
                        let href = $(this).attr('data-href') + '?question1=' + key;
                        window.location.href = href;
                    }
                }
            });
        }
    }
});